<template>
    <div id="main-page">
        <BaseCallout
            v-if="previewMode"
            type="warning">
            <strong>{{ $t('eventRegistration.caution') }}:</strong> {{ $t('eventRegistration.previewActive') }}
        </BaseCallout>
        <div v-if="eventIsLoaded">
            <div
                v-if="stepsBefore.length"
                class="d-md-none">
                <MobileMenu
                    v-for="step in stepsBefore"
                    :key="step.name"
                    :step="step" />
            </div>
            <div class="current-step">
                <MobileMenu
                    :key="currentStep.name"
                    :step="currentStep" />
                <NuxtPage keepalive />
            </div>
            <div class="d-md-none">
                <MobileMenu
                    v-for="step in stepsAfter"
                    :key="step.name"
                    :step="step" />
            </div>
        </div>
    </div>
</template>

<script>
import MobileMenu from "@/components/pages/registration/MobileMenu";
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import registrationStepsAndValidationMixin from "@/mixins/registration/registrationStepsAndValidationMixin";
import registrationGroupMixin from "@/mixins/registration/registrationGroupMixin";


export default {
    name: "EventId",
    components: {
        MobileMenu
    },
    mixins: [mainRegistrationMixin, registrationGroupMixin, registrationStepsAndValidationMixin],
    head() {
        return {
            title: this.$get(this.eventData, 'shortText', null),
            meta: [
                {
                    hid: 'description',
                    name: 'description'
                }
            ]
        }
    },
    validate({params}) {
        // Must be a number
        return /^\d+$/.test(params.id)
    },
    data() {
        return {
            reloadInterval: null,
            stepName: null
        }
    },
    computed: {
        eventId() {
            return parseInt(this.$route.params.id)
        }
    },
    methods: {
        scrollToStep(activeStep, deep = 0) {
            const el = document.getElementById(activeStep.name);
            if (deep > 5) {
                return
            }
            if (el) {
                el.scrollIntoView({behavior: "smooth"});
            } else {
                setTimeout(() => {
                    this.scrollToStep(activeStep, deep + 1)
                }, 100 * (deep + 1))
            }
        },
        async fetch() {
            await this.fetchEventData(this.eventId)
        }
    },
    mounted() {
        this.scrollToStep(this.activeStep);
        this.reloadInterval = window.setInterval(() => {
            this.fetchEventData(this.eventId, true)
        }, 120000);
    },
    created() {
        this.previewMode = (this.$route.query.preview === "true")

        if (this.$route.query.group === "true")
            this.initGroupRegistrationCreationMode()

        this.caregiverToken = this.$route.query.caregiverToken
        this.caregiverCheckToken = this.$route.query.caregiverCheckToken
        this.groupRegistrarToken = this.$route.query.groupRegToken
        this.groupParticipantToken = this.$route.query.groupParToken
        this.noCheckToken = this.$route.query.noCheckToken
    },
    beforeUnmount() {
        clearInterval(this.reloadInterval)
    },
    watch: {
        'activeStep.name': {
            handler(newValue, oldValue) {

                this.redirectUserToEnabledStep()
                const el = document.getElementById(oldValue);
                if (el)
                    el.scrollIntoView({behavior: "smooth"});

                setTimeout(() => {
                    this.scrollToStep(this.activeStep);
                }, 400)

            }
        },
        eventIsLoaded: {
            handler(eventIsLoaded) {
                if (eventIsLoaded) {
                    this.redirectUserToEnabledStep()
                }
            },
            immediate: true
        },
        eventId: {
            handler() {
                this.$nextTick(() => {
                    this.fetch()
                })
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.current-step {
    margin: map-get($spacers, 5) 0;

    @include media-breakpoint-up(md) {
        margin: 0;
    }
}

.current-step:first-child {
    margin-top: 0;
}
</style>
